module.exports = __webpack_public_path__ + "img/image-22.162c5348.webp";